import React, { useLayoutEffect, useContext } from "react";
import ApiUser from "../../../app/api/admin/user/ApiUser";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import ListHeaderItem from "../../modules/list/__header-item";
import ListBodyItem from "../../modules/list/__body-item";
import ButtonLinkShow from "../../components/button-link/__show";
import ButtonLinkAdd from "../../components/button-link/__add";

// Список пользователей панели (сервер сортирует по username).
export default function UsersIndex({ ...other }) {
    return <Page {...other}>
        <UsersIndexContent/>
    </Page>;
}

function UsersIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    useLayoutEffect(() => {
        contextContent.setTitle('Пользователи');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const header = [
        <ListHeaderItem key="id" name="id" isSort={false}>ID</ListHeaderItem>,
        <ListHeaderItem key="username" name="username" isSort={false}>Логин</ListHeaderItem>,
        <ListHeaderItem key="name" name="name" isSort={false}>Имя</ListHeaderItem>,
        <ListHeaderItem key="email" name="email" isSort={false}>Email</ListHeaderItem>,
        <ListHeaderItem key="is_active" name="is_active" isSort={false}>Активен</ListHeaderItem>,
        <ListHeaderItem key="create" name="create" isSort={false}>
            {contextContent.checkPermission('create')
                ? <ButtonLinkAdd className="button-link_white" title="Добавить" href={contextPage.routes.create.url()}/> : null}
        </ListHeaderItem>,
    ];

    const renderRow = (row) => [
        <ListBodyItem key="id">{row.id}</ListBodyItem>,
        <ListBodyItem key="username">{row.username}</ListBodyItem>,
        <ListBodyItem key="name">{row.name}</ListBodyItem>,
        <ListBodyItem key="email">{row.email}</ListBodyItem>,
        <ListBodyItem key="is_active">
            <span className={`badge ${row.is_active ? 'badge_online' : 'badge_offline'}`}>
                {row.is_active ? 'да' : 'нет'}
            </span>
        </ListBodyItem>,
        <ListBodyItem key="show">
            {contextContent.checkPermission('show')
                ? <ButtonLinkShow className="button-link_blue" title="Просмотр" href={contextPage.routes.show.url({ id: row.id })}/> : null}
        </ListBodyItem>,
    ];

    return <List
        header={header}
        ApiModel={ApiUser}
        renderRow={renderRow}
        defaultSortKey="username"
        defaultSortIsAsc={true}
    />;
}
